module.exports = __webpack_public_path__ + "static/biocidics-logo-d2343ac5de11eca8fa36df37b6146950.svg";